import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../../config';
import { translate as t } from '../../../../lib/I18n';

import CollectionStationsStore from '../../../../stores/CollectionStationsStore';
import connectToStores from '../../../../helpers/connectToStores';

import Icon from '../../../general/Icon';
import FeatureFlag from '../../../general/FeatureFlag';
import FormattedHTMLMessage from '../../../general/FormattedHTMLMessage';
import ExternalLink from '../../../general/ExternalLink';

function _getStateFromStores () {
    return {
        location: CollectionStationsStore.getSelectedLocationName(),
    };
}

function Success({ location }) {
    return (
        <div className="padding-top padding-bottom">
            <div className="confirmation text-center">
                <Icon icon="selected margin-bottom--sm otrl-xl" />
                <p className="text-weight--normal alert-success">{ t('confirmation.keygo.success') }</p>
                { location && (
                    <p className="text-center text-weight--normal">
                        <FormattedHTMLMessage
                            message='account.smartcard.keygo.ready'
                            location={ location }
                            keygobrand={ <FormattedHTMLMessage message='account.smartcard.text.keygo' /> }
                        />
                    </p>
                ) }
                { !location && (
                    <FeatureFlag name="enableKeyGoCollectionInfo">
                        <p className="text-center text-weight--normal">
                            <FormattedHTMLMessage
                                message='account.smartcard.keygo.collect.info'
                                keygobrand=
                                    { <FormattedHTMLMessage message='account.smartcard.text.keygo' /> }
                            />
                        </p>
                        <p className="text-center text-weight--normal">
                            <ExternalLink
                                message={ t('account.smartcard.keygo.collect.map', {
                                    keygobrand: t('account.smartcard.text.keygo')
                                }) }
                                href={ config.get('keyGoCollectionMapUrl') }
                            />
                        </p>
                    </FeatureFlag>
                ) }
            </div>
        </div>
    );
}

Success.propTypes = {
    location: PropTypes.string
};

Success.defaultProps = {
    location: null
};

export default connectToStores([ CollectionStationsStore ], _getStateFromStores)(Success);



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/Success.js